<template>
        <div>

            <div class="row nb-margin-top mb-3">
                <form-field ref="code" v-model="code2" type="text" col="12" label="Code" case="normal"></form-field>
            </div>

        </div>
</template>

<script>

import { SysVars } from '../main'

export default {
    props: {
        filial: {},
    },

    data() {
        return {
            code2: null,
        }
    },

    computed: {
        status: function () {
            return ''
        }
    },

    methods: {
        data (value) {
            return formatDate(value)
        },        

        closeForm () {
            this.$emit('closeform')
        },

        async loadData () {
            //CARREGA OS DADOS DO CERTIFICADO DA FILIAL
            const queryString = window.location.search;
            const urlParams = new URLSearchParams(queryString);
            this.code2 = urlParams.get('code');
        },


    },

    created () {
        this.loadData()
    }

}

</script>

<style>


</style>



// WEBPACK FOOTER //
// src/forms/app-mercadolivre-code.vue